<script setup lang="ts">
import { computed, onMounted } from 'vue';
import { useRoute } from 'vue-router';
import NavBar from '@/components/NavBar.vue';
import { useGameStore } from '@/stores/game';

const route = useRoute();
const game = useGameStore();

const showNav = computed(() => route.name !== 'login' && game.isAuthenticated);

onMounted(async () => {
  // If we have a token in localStorage on load, fetch fresh data
  if (game.token && !game.user) {
    try { await game.loadAll(); }
    catch { game.logout(); }
  }
});
</script>

<template>
  <NavBar v-if="showNav" />
  <main>
    <RouterView />
  </main>
</template>
